import { PublicationListOrderingKey } from "../../../publicationList.types";

export const EMPTY_SHELL_VALUE = "-";

export type Ordering = "none" | "asc" | "desc";

export const ORDERING_TABLE = {
  asc: "desc",
  desc: "none",
  none: "asc",
} as const;

export interface TableHeaderList {
  title: string;
  orderingTitle: PublicationListOrderingKey;
  ordering: Ordering;
}

export const TABLE_HEADER_LIST: TableHeaderList[] = [
  {
    title: "Publication\nID",
    orderingTitle: "publicationId",
    ordering: "none",
  },
  {
    title: "DOI",
    orderingTitle: "doi",
    ordering: "none",
  },
  {
    title: "Publication\nDate",
    orderingTitle: "publicationDate",
    ordering: "none",
  },

  {
    title: "Publication\nType",
    orderingTitle: "publicationType",
    ordering: "none",
  },
  {
    title: "Topic Type",
    orderingTitle: "topicType",
    ordering: "none",
  },
  {
    title: "Journal Name\n(eISSN)",
    orderingTitle: "journalName",
    ordering: "none",
  },
  {
    title: "Volume",
    orderingTitle: "volume",
    ordering: "none",
  },
  {
    title: "Issue",
    orderingTitle: "issue",
    ordering: "none",
  },
  {
    title: "Unsuitable",
    orderingTitle: "articleRejectReason",
    ordering: "none",
  },
  {
    title: "Title",
    orderingTitle: "title",
    ordering: "none",
  },
  {
    title: "Affiliation",
    orderingTitle: "affiliationList",
    ordering: "none",
  },

  {
    title: "Status",
    orderingTitle: "draftArticleStatusHighest",
    ordering: "none",
  },
  {
    title: "Start Date",
    orderingTitle: "startDate",
    ordering: "none",
  },
  {
    title: "Complete\nDate",
    orderingTitle: "completeDate",
    ordering: "none",
  },
  {
    title: "MC\nEditor",
    orderingTitle: "mcEditor",
    ordering: "none",
  },
  {
    title: "FT\nEditor",
    orderingTitle: "ftEditor",
    ordering: "none",
  },
];
